import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import GoogleSecurityCommandCenterConfigListing from './GoogleSecurityCommandCenterConfigListing'
import GoogleSecurityCommandCenterCredentialsForm from './GoogleSecurityCommandCenterCredentialsForm'

export default function GoogleSecurityCommandCenterPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={GoogleSecurityCommandCenterCredentialsForm}
            PullConfigListingView={GoogleSecurityCommandCenterConfigListing}
        />
    )
}
